import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "mailWithStatus" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "icon" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M21 11.1V6.3C21 5.30589 20.1941 4.5 19.2 4.5H4.8C3.80589 4.5 3 5.30589 3 6.3V17.1C3 18.0941 3.80589 18.9 4.8 18.9H12",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector_2",
      d: "M21 7.20001L12.927 12.33C12.6491 12.5041 12.3279 12.5964 12 12.5964C11.6721 12.5964 11.3509 12.5041 11.073 12.33L3 7.20001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }